import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectUser }  from "../../features/userSlice"
import "./LandingPage.css"

const LandingPage = () => {
  const navigate = useNavigate()
  const user     = useSelector(selectUser)

  // ── Redirect in an EFFECT, never during render ────────────────
  // Calling navigate() in the render body (as the previous version did)
  // is illegal in React — it fires a navigation mid-render, leaves the
  // router inconsistent, and the `return null` below then paints a BLANK
  // page. Moving it into useEffect is the fix for the blank landing page.
  useEffect(() => {
    if (user?.token) {
      navigate("/dashboard", { replace: true })
    }
  }, [user?.token, navigate])

  // While the effect redirects a logged-in user, render nothing briefly.
  if (user?.token) return null

  return (
    // ✅ No <MainScreen> — completely standalone
    <div className="lnd-shell">

      {/* ── NAVBAR ── */}
      <nav className="lnd-nav">
        <div className="lnd-nav-left">
          <div className="lnd-logo-box">S</div>
          <span className="lnd-brand">
            <em>Singhal</em>ERP
          </span>
        </div>
        <div className="lnd-nav-links">
          <span>Features</span>
          <span>Modules</span>
          <span>Support</span>
        </div>
        <button
          className="lnd-signin-btn"
          onClick={() => navigate("/login")}
        >
          Sign In →
        </button>
      </nav>

      {/* ── HERO ── */}
      <section className="lnd-hero">
        {/* Decorative grid background */}
        <div className="lnd-hero-bg" />

        <div className="lnd-hero-content">
          <div className="lnd-badge">
            <span className="lnd-badge-dot" />
            Singhal Group of Industries · ERP Suite v4.0
          </div>

          <h1 className="lnd-h1">
            Welcome to <span className="lnd-accent"><em>Singhal</em></span><span className="lnd-erp">ERP</span>
            <br />Your Complete Business OS
          </h1>
          <p className="lnd-sub">
            Finance · Inventory · Sales · Purchase · Production
            <br />
            All connected. Real-time. Oracle-powered.
          </p>

          <div className="lnd-hero-btns">
            <button
              className="lnd-primary-btn"
              onClick={() => navigate("/login")}
            >
              Sign In to Workspace →
            </button>
            <button className="lnd-outline-btn">
              Watch Demo
            </button>
          </div>

          {/* Feature cards */}
          <div className="lnd-feat-grid">
            <div className="lnd-feat-card">
              <div className="lnd-feat-icon">⚡</div>
              <div className="lnd-feat-title">Oracle Pool Backend</div>
              <div className="lnd-feat-sub">
                Connection pooling for instant response on all queries
              </div>
            </div>
            <div className="lnd-feat-card">
              <div className="lnd-feat-icon">🔒</div>
              <div className="lnd-feat-title">Role-Based Access</div>
              <div className="lnd-feat-sub">
                Menu, form and field-level security per user
              </div>
            </div>
            <div className="lnd-feat-card">
              <div className="lnd-feat-icon">📊</div>
              <div className="lnd-feat-title">MDI Workspace</div>
              <div className="lnd-feat-sub">
                Open multiple forms simultaneously — SAP-style
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="lnd-footer">
        <span>© 2026 Singhal Group of Industries · SinghalERP v4.0</span>
        <span>Oracle 11g · Node.js · React 18 · Redux Toolkit</span>
      </footer>

    </div>
  )
}

export default LandingPage
